var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-link',{staticClass:"w-select-option",class:{'keyboard-nav':_vm.keyboardNavigation, disabled: _vm.disabled},attrs:{"tabindex":_vm.disabled ? -1 : 0,"disabled":_vm.disabled},on:{"click":function($event){return _vm.clicked()}},nativeOn:{"keyup":function($event){return _vm.onKeyUp($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }